export default "__VITE_ASSET__44a4580e__"